import * as React from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import GppMaybeOutlinedIcon from "@mui/icons-material/GppMaybeOutlined";
import { AppStandardButton } from "../AppButtons";

interface NoCoverageWarningDialogProps {
  open: boolean;
  onClose: () => void;
  onContinueWithoutCoverage: () => void;
  onAddCoverageAndContinue: () => void;
  title: string;
  body: string;
  continueWithoutCoverageLabel: string;
  addCoverageLabel: string;
  primaryColor?: string;
}

export function NoCoverageWarningDialog({
  open,
  onClose,
  onContinueWithoutCoverage,
  onAddCoverageAndContinue,
  title,
  body,
  continueWithoutCoverageLabel,
  addCoverageLabel,
  primaryColor,
}: NoCoverageWarningDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="no-coverage-warning-title"
      aria-describedby="no-coverage-warning-body"
      disableRestoreFocus
      sx={{
        "& .MuiDialog-container": {
          alignItems: "center",
          justifyContent: "center",
        },
        "& .MuiDialog-paper": {
          margin: "auto",
          maxWidth: "640px",
          width: { xs: "calc(100% - 32px)", sm: "100%" },
          borderRadius: "12px",
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 12,
          top: 12,
          color: "#000000",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          padding: "40px 32px 32px",
        }}
      >
        <GppMaybeOutlinedIcon
          sx={{ color: "#f5a623", marginBottom: "20px" }}
          style={{ fontSize: 80, width: 80, height: 80 }}
        />
        <h2
          id="no-coverage-warning-title"
          className="text-xl font-bold mb-3"
          style={{ margin: 0, marginBottom: "12px" }}
        >
          {title}
        </h2>
        <p
          id="no-coverage-warning-body"
          style={{ color: "#333333", marginBottom: "24px" }}
        >
          {body}
        </p>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column-reverse", sm: "row" },
            flexWrap: "nowrap",
            gap: "12px",
            justifyContent: "center",
            width: "100%",
            overflowX: { xs: "visible", sm: "auto" },
            padding: "4px",
          }}
        >
          <Box sx={{ flexShrink: 0, width: { xs: "100%", sm: "auto" } }}>
            <AppStandardButton
              variant="outlined"
              onClick={onContinueWithoutCoverage}
            >
              <Box
                component="p"
                className="text-black normal-case"
                sx={{ whiteSpace: { xs: "normal", sm: "nowrap" }, margin: 0 }}
              >
                {continueWithoutCoverageLabel}
              </Box>
            </AppStandardButton>
          </Box>
          <Box sx={{ flexShrink: 0, width: { xs: "100%", sm: "auto" } }}>
            <AppStandardButton
              onClick={onAddCoverageAndContinue}
              style={primaryColor ? { background: primaryColor } : undefined}
            >
              <Box
                component="p"
                className="normal-case"
                sx={{
                  whiteSpace: { xs: "normal", sm: "nowrap" },
                  margin: 0,
                  ...(primaryColor ? { color: "#ffffff" } : undefined),
                }}
              >
                {addCoverageLabel}
              </Box>
            </AppStandardButton>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
